/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import ContentWrapper from 'Component/ContentWrapper';
import { HistoryType } from 'Type/Common';
import CmsBlock from 'Component/CmsBlock';

import BlogCategories from '../../component/BlogCategories';
import BlogPostCard from '../../component/BlogPostCard';
import { POSTS_LISTING } from './PostsListing.config';

import './PostsListing.style';


/** @namespace ScandiPWA/Blog/Component/PostsListing/Component */
export class PostsListing extends PureComponent {
    static propTypes = {
        updateBreadcrumbs: PropTypes.func.isRequired,
        updateMeta: PropTypes.func.isRequired,
        history: HistoryType.isRequired,
        setHeaderState: PropTypes.func.isRequired,
        isLoaded: PropTypes.bool,
        pageSize: PropTypes.number.isRequired,
        posts: PropTypes.shape({
            items: PropTypes.array,
            count: PropTypes.number
        }).isRequired,
        categories: PropTypes.shape({
            items: PropTypes.array,
            count: PropTypes.number
        }).isRequired,
        category: PropTypes.string.isRequired,
        blog_title: PropTypes.string.isRequired,
        loadMore: PropTypes.func.isRequired
    };

    static defaultProps = {
        isLoaded: false
    };

    componentDidMount() {
        this.updateMeta();
        this.setHeaderState();
    }

    updateBreadcrumbs() {
        const { updateBreadcrumbs, mfblog_permalink_route } = this.props;
        const breadcrumbs = [
            ...this.getCategoryBreadcrumb(),
            {
                url: `/${mfblog_permalink_route}`,
                name: __('Blog')
            }
        ];

        updateBreadcrumbs(breadcrumbs);
    }

    updateMeta() {
        const { updateMeta, redirect_code_previous } = this.props;

        updateMeta({
            title: __('Blog'),
            canonical_url: window.location.href,
            redirect_from: window.location.pathname,
            redirect_code_previous
        });
    }

    getDefaultTitle() {
        const { title, blog_title } = this.props;

        if(blog_title)
            return blog_title

        if(title) {
            return title.replace("-", " ");
        }

        return __('HC INSIDER')
    }

    renderTitle() {
        this.updateBreadcrumbs();
        return (
            <h1 block="PostsListing" elem="Title">
                { this.getCategoryTitle() || this.getDefaultTitle() }
            </h1>
        );
    }

    /**
     * Gets the canonical url for the specific post
     */
    getCanonicalUrl() {
    return window.location.href;
}

    getCategoryTitle() {
        const { category, categories: { items } } = this.props;
        const { title } = items.find(({ identifier }) => identifier === category) || {};

        return title;
    }

    getCategoryDescription() {
        return <CmsBlock identifier={ 'blog_main_page_description' } />;
    }

    getCategoryBreadcrumb() {
        const { categories: { count }, category } = this.props;
        const title = this.getCategoryTitle() || '';

        if (count && title) {
            return [
                {
                    name: title
                }
            ];
        }

        if (!count && category) {
            return [
                {
                    name: ''
                }
            ];
        }

        return [];
    }

    setHeaderState() {
        const { setHeaderState, history } = this.props;
        setHeaderState({
            name: POSTS_LISTING,
            title: 'Blog',
            onBackClick: () => history.goBack()
        });
    }

    render() {
        const { category } = this.props;

        return (
            <main block="PostsListing" className={'main'}>
                <ContentWrapper label="PostsListing">
                    { this.renderTitle() }
                    { this.getCategoryDescription() }
                    <div block="PostsListing" elem="ColumnWrapper">
                        <div block="PostsListing" elem="Sidebar">
                            <BlogCategories />
                        </div>
                        <div block="PostsListing" elem="Grid">
                            <CmsBlock identifier={ 'blog_main_page_top' } />
                        </div>
                    </div>
                </ContentWrapper>
                <ContentWrapper label="PostsListing" elem="Bottom">
                    <CmsBlock identifier={ 'blog_main_page_bottom' } />
                </ContentWrapper>
            </main>
        );
    }
}

export default PostsListing;
